import { combineReducers } from "redux";
import { APP_TYPES } from "../../types";

function createAppReducer() {
  const { onLine } = navigator;

  const isOnline = (state = onLine, action) => {
    switch (action.type) {
      case APP_TYPES.APP_IS_ONLINE:
      case APP_TYPES.APP_IS_OFFLINE:
        return action.isOnline;
      default: {
        return state;
      }
    }
  };

  return combineReducers({
    isOnline,
  });
}

export default createAppReducer();
